// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"847e8565","453":"5e560239","732":"9fb3cf79","977":"95c8f51e"}[chunkId] + ".chunk.js";
};